import React from 'react'
import { ToastsStore, ToastsContainer, ToastsContainerPosition } from 'react-toasts'
import CampaignStepper from './SubComponents/CampaignStepper'

interface Props {
  role?: string
}
const EditCampaign = (props: Props) => {
  const { role = 'client' } = props
  return (
    <div>
      <ToastsContainer
        className="toast"
        store={ToastsStore}
        position={ToastsContainerPosition.TOP_CENTER}
      />
      <CampaignStepper action="EDIT" role={role} />
    </div>
  )
}
export default EditCampaign
